export default __webpack_public_path__ + "static/media/ClubBills.148d7fe72a31037fdbb2d09bef40e08f.webp";